import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { navigate } from '@reach/router';
import * as styles from './clarification-text.module.css';
import Layout from '../components/layout';
import SEO from '../components/seo';
import TextPanel from '../components/text-panel';
import ClarificationText from '../components/clarification-text';
import NotFound from './404';

function ClarificationTextPage() {
  const { t, i18n } = useTranslation('clarificationtext');

  useEffect(
    () => {
      switch (i18n.language) {
        case 'tr':
          break;
        case 'en':
          navigate('/404');
          break;
        default:
          navigate(`/${i18n.language}/404`);
      }
    },
    [i18n.language]
  );

  if (i18n.language !== 'tr') {
    return <NotFound />;
  }

  return (
    <Layout>
      <SEO
        title={t('meta.title')}
        description={t('meta.description')}
      />
      <main className={styles.main}>
        <TextPanel>
          <ClarificationText />
        </TextPanel>
      </main>
    </Layout>
  );
}

export default ClarificationTextPage;
